import BuildIcon from "@mui/icons-material/Build";
import LaptopMacIcon from "@mui/icons-material/LaptopMac";

import { ThinkingIndicator } from "@/shared/components";
import { RobotoTypography } from "@/shared/components/RobotoTypography";
import { AgentThreadToolUseContent } from "@/shared/domain/agentThread/AgentThreadRecord";
import {
  displayToolName,
  isClientToolName,
} from "@/shared/domain/agentThread/clientTools/ClientTools";

import styles from "./AssistantToolUseContent.module.css";

interface AssistantToolUseContentProps {
  toolUse: AgentThreadToolUseContent;
}

const AssistantToolUseContent = ({ toolUse }: AssistantToolUseContentProps) => {
  const isClient = isClientToolName(toolUse.tool_name);
  const Icon = isClient ? LaptopMacIcon : BuildIcon;
  return (
    <div className={styles.indentedContainer}>
      <div className={styles.messageContainer}>
        <ThinkingIndicator size="small" />
        <div className={styles.textAndIconContainer}>
          <Icon
            className={isClient ? styles.clientToolIcon : styles.buildIcon}
          />
          <RobotoTypography className={styles.text}>
            Using {isClient ? "Client " : ""}Tool{" "}
            <b>{displayToolName(toolUse.tool_name)}</b>
          </RobotoTypography>
        </div>
      </div>
    </div>
  );
};

export { AssistantToolUseContent };
